import { apiClient } from '@/lib/api';
import { TransportMode, FreightLegType } from '../types/freight-route.types';
import { FreightProvider } from './freight-provider-service';

export interface CatalogFreightLeg {
  id: string;
  tenantId: string;
  routeId: string | null;
  legOrder: number | null;
  origin: string;
  destination: string;
  originLocationId: string | null;
  destinationLocationId: string | null;
  transportMode: TransportMode;
  legType: FreightLegType;
  ratePerCbm: number;
  ratePerKg: number;
  ratePerContainer: number | null;
  minimumCharge: number | null;
  estimatedDays: number | null;
  providerId: string | null;
  provider?: Pick<FreightProvider, 'id' | 'name' | 'transportModes'> | null;
  route?: { id: string; name: string } | null;
  isActive: boolean;
  sapCode?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCatalogLegInput {
  origin?: string;
  destination?: string;
  originLocationId?: string | null;
  destinationLocationId?: string | null;
  transportMode: TransportMode;
  legType: FreightLegType;
  ratePerCbm?: number;
  ratePerKg?: number;
  ratePerContainer?: number | null;
  minimumCharge?: number | null;
  estimatedDays?: number | null;
  providerId?: string | null;
  isActive?: boolean;
  sapCode?: string | null;
}

export interface CatalogLegFilters {
  mode?: TransportMode;
  origin?: string;
  destination?: string;
  providerId?: string;
  q?: string;
}

class FreightLegCatalogService {
  async list(filters?: CatalogLegFilters): Promise<CatalogFreightLeg[]> {
    const params = new URLSearchParams();
    if (filters?.mode) params.set('mode', filters.mode);
    if (filters?.origin) params.set('origin', filters.origin);
    if (filters?.destination) params.set('destination', filters.destination);
    if (filters?.providerId) params.set('providerId', filters.providerId);
    if (filters?.q) params.set('q', filters.q);
    const qs = params.toString();
    return apiClient.get(`/api/freight-legs${qs ? `?${qs}` : ''}`);
  }

  async create(data: CreateCatalogLegInput): Promise<CatalogFreightLeg> {
    return apiClient.post('/api/freight-legs', data);
  }

  async update(id: string, data: Partial<CreateCatalogLegInput>): Promise<CatalogFreightLeg> {
    return apiClient.patch(`/api/freight-legs/${id}`, data);
  }

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/api/freight-legs/${id}`);
  }
}

export const freightLegCatalogService = new FreightLegCatalogService();
